module.exports = __webpack_public_path__ + "img/woonstad@2x.e1a8e7c1.png";